var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#80C56E",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_3038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5569 16.8457C39.6983 17.2323 41.2694 21.8335 38.0472 27.2593C36.09 30.5548 33.1184 30.7729 32.8274 30.7864C32.6569 30.5501 30.9792 28.0877 32.3422 24.5053C34.5862 18.6073 39.1662 16.9755 39.5569 16.8457Z",
    fill: "#80C56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5566 16.8457L32.8271 30.7864C33.1182 30.7728 36.0898 30.5548 38.047 27.2593C41.2693 21.8335 39.6981 17.2323 39.5566 16.8457Z",
    fill: "#66AD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4434 16.8457C20.302 17.2323 18.7308 21.8335 21.9531 27.2593C23.9103 30.5548 26.8819 30.7729 27.1729 30.7864C27.3433 30.5501 29.021 28.0877 27.658 24.5053C25.414 18.6073 20.8341 16.9755 20.4434 16.8457Z",
    fill: "#80C56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.658 24.5053C25.414 18.6073 20.834 16.9755 20.4434 16.8457C24.4227 24.4463 26.5692 29.3148 27.1892 30.7633C27.428 30.422 28.9859 27.9953 27.658 24.5053Z",
    fill: "#66AD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 14C29.5203 14.4656 23.9746 20.0851 24.8566 30.2945C25.3923 36.4956 29.584 38.9122 30.0001 39.1374C30.4161 38.9122 34.6079 36.4956 35.1436 30.2945C36.0256 20.0851 30.4798 14.4656 30.0001 14Z",
    fill: "#80C56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 14V39.1374C30.4161 38.9122 34.6078 36.4956 35.1435 30.2945C36.0255 20.0851 30.4797 14.4656 30 14Z",
    fill: "#66AD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8729 29.6273C42.9163 26.0411 42.5631 22.708 42.5631 22.708C42.5631 22.708 40.5537 23.6031 35.5038 26.8664C31.5785 29.403 30.364 33.8504 30 35.049H34.6133C37.9668 35.049 40.936 32.8473 41.8729 29.6273Z",
    fill: "#80C56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5632 22.708C42.5632 22.708 37.3732 32.9607 30 35.0491H34.6133C37.9668 35.0491 40.936 32.8473 41.8729 29.6274C42.9163 26.0412 42.5632 22.708 42.5632 22.708Z",
    fill: "#66AD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1272 29.6273C17.0838 26.0411 17.437 22.708 17.437 22.708C17.437 22.708 19.4464 23.6031 24.4963 26.8664C28.4216 29.403 29.6361 33.8504 30.0001 35.049H25.3868C22.0333 35.049 19.0641 32.8473 18.1272 29.6273Z",
    fill: "#80C56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 35.0491C29.6362 33.8504 28.4217 29.4031 24.4964 26.8664C19.4464 23.6031 17.437 22.708 17.437 22.708C17.437 22.708 22.6269 32.9608 30.0002 35.0491Z",
    fill: "#66AD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3361 46.0003H26.6641C24.8944 46.0003 23.3763 44.7385 23.0528 42.9986L21.6223 35.3066H38.3779L36.9474 42.9986C36.6238 44.7385 35.1058 46.0003 33.3361 46.0003Z",
    fill: "#FEC37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.137 35.3067L33.7066 42.9987C33.383 44.7385 31.8649 46.0003 30.0952 46.0003H33.336C35.1057 46.0003 36.6238 44.7385 36.9473 42.9986L38.3778 35.3066H35.137V35.3067Z",
    fill: "#F9AE5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6701 37.0347H21.3304C20.6277 37.0347 20.0581 36.4651 20.0581 35.7625C20.0581 35.0599 20.6277 34.4902 21.3304 34.4902H38.6702C39.3728 34.4902 39.9424 35.0599 39.9424 35.7625C39.9424 36.4651 39.3728 37.0347 38.6701 37.0347Z",
    fill: "#F2A559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.67 34.4902H36.6316V37.0347H38.67C39.3726 37.0347 39.9422 36.4651 39.9422 35.7625C39.9423 35.0599 39.3727 34.4902 38.67 34.4902Z",
    fill: "#EA8F3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_3038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.e63ce4afdbec78f26532f84f78f7729d.svg";
export { ForwardRef as ReactComponent };